(function () {
  'use strict';

  const instances = new Map();

  class SeriesAnchor {
    constructor(root) {
      this.root = root;
      this.sticky = root.querySelector('[data-aw-series-anchor-sticky]');
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      if (!this.sticky) {
        return;
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.onResize();
      this.onScroll();
    }

    getHeaderHeight() {
      const header = document.querySelector('.aw-header.is-sticky-visible .aw-header__sticky, .aw-header__sticky');
      return header ? header.getBoundingClientRect().height : 72;
    }

    onResize() {
      this.root.style.setProperty('--aw-series-anchor-sticky-top', `${this.getHeaderHeight()}px`);
    }

    onScroll() {
      if (window.matchMedia('(min-width: 768px)').matches) {
        this.root.classList.remove('is-sticky-visible');
        return;
      }

      const threshold = this.root.getBoundingClientRect().bottom + window.scrollY;
      this.root.classList.toggle('is-sticky-visible', window.scrollY > threshold + 8);
    }

    destroy() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }
  }

  function mount(root) {
    if (instances.has(root)) {
      return;
    }

    instances.set(root, new SeriesAnchor(root));
  }

  function unmount(root) {
    const instance = instances.get(root);
    if (!instance) {
      return;
    }

    instance.destroy();
    instances.delete(root);
  }

  function mountAll() {
    document.querySelectorAll('[data-section-type="aw-series-anchor"]').forEach(mount);
  }

  document.addEventListener('DOMContentLoaded', mountAll);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches('[data-section-type="aw-series-anchor"]')) {
      mount(event.target);
    }
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches('[data-section-type="aw-series-anchor"]')) {
      unmount(event.target);
    }
  });
})();
